var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrustpilotRatings3StarRgb = function SvgTrustpilotRatings3StarRgb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 18,
    viewBox: "0 0 97 18"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_3star-RGB_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.598.012H19V18H.598Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_3star-RGB_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 .012h19V18H19Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_3star-RGB_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 .012h19V18H39Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_3star-RGB_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58 .012h19V18H58Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_3star-RGB_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78 .012h17.895V18H78Zm0 0"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_3star-RGB_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1e1e1e",
      fillOpacity: 1
    },
    d: "M18.465.012H.598v18h17.867Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_3star-RGB_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1e1e1e",
      fillOpacity: 1
    },
    d: "M37.824.012h-17.87v18h17.87Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_3star-RGB_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1e1e1e",
      fillOpacity: 1
    },
    d: "M57.18.012H39.313v18H57.18Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_3star-RGB_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#dcdce6",
      fillOpacity: 1
    },
    d: "M76.54.012H58.667v18h17.871Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_3star-RGB_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#dcdce6",
      fillOpacity: 1
    },
    d: "M95.895.012H78.027v18h17.868Zm0 0"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "m9.531 12.145 2.719-.696 1.133 3.528Zm6.254-4.56H11L9.531 3.052 8.06 7.586H3.277l3.871 2.812-1.468 4.54 3.87-2.813 2.384-1.727ZM28.887 12.145l2.718-.696 1.137 3.528Zm6.254-4.56h-4.782l-1.472-4.534-1.469 4.535h-4.785l3.875 2.812-1.473 4.54 3.871-2.813 2.383-1.727ZM48.246 12.145l2.719-.696 1.133 3.528Zm6.254-4.56h-4.785l-1.469-4.534-1.473 4.535h-4.78l3.87 2.812-1.468 4.54 3.87-2.813 2.383-1.727ZM67.602 12.145l2.718-.696 1.137 3.528Zm6.253-4.56h-4.78l-1.473-4.534-1.47 4.535h-4.784l3.875 2.812-1.473 4.54 3.871-2.813 2.383-1.727ZM86.96 12.145l2.72-.696 1.132 3.528Zm6.255-4.56H88.43l-1.47-4.534-1.472 4.535h-4.781l3.871 2.812-1.469 4.54 3.871-2.813 2.383-1.727Zm0 0"
  }));
};
export default SvgTrustpilotRatings3StarRgb;